import clone from 'clone'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { BATCH_MANAGER_INIT_LOADING, BATCH_MANAGER_INIT_SUCCESS, BATCH_MANAGER_INIT_FAIL } from '@/store/types'
export const initialState = {
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {}

const mutations = {
  [BATCH_MANAGER_INIT_LOADING](state, err) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [BATCH_MANAGER_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [BATCH_MANAGER_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async batchManagerInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.batchJob
    commit(BATCH_MANAGER_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(BATCH_MANAGER_INIT_SUCCESS, commitResult)
    } catch (err) {
      commit(BATCH_MANAGER_INIT_FAIL, extractMessages(err))
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
